import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { authSlice, requestSlice } from "common";
import { notifySlice } from "common/notify/slice";
import {homeSlice} from "../common/home/store/slice";

const reducer = combineReducers({
  auth: authSlice.reducer,
  home: homeSlice.reducer,
  notify: notifySlice.reducer,
  request: requestSlice.reducer,
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
